import { isMockMode, post, simulateDelay } from "../../api";

export interface DeleteFeatureRequest {
	featureId: number;
}

export const deleteFeature = (req: DeleteFeatureRequest) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`products/deletefeature`, req);
};
